class SiteHeader {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;
		this.html = document.querySelector('html');
		this.megaMenuItems = el.querySelectorAll('.menu-has-children');
		this.headerOverlay = document.getElementById('header-overlay');
		
		this.updateHeaderHeightVar();
		this.setupEventHandlers();
	}

	setupEventHandlers() {
		// desktop mega menu
		this.megaMenuItems.forEach(m => {
			m.addEventListener('click', (e) => {
				// open menu
				if (m.classList.contains('menu-has-children') && !m.classList.contains('active')) {
					// close all mega menu items
					this.megaMenuItems.forEach(mml => {
						mml.classList.remove('active');
					});
					// show background overlay
					this.headerOverlay.classList.add('active');
					// open mega menu items
					m.classList.add('active');
				} else {
					// close menu
					this.megaMenuItems.forEach(mml => {
						mml.classList.remove('active');
					});
					// hide background overlay
					this.headerOverlay.classList.remove('active');
				};
			});
		})

		// close mega menu when document is clicked
		document.addEventListener('click', (event) => {
			if (!this.el.contains(event.target)) {
				this.megaMenuItems.forEach(mml => {
					mml.classList.remove('active');
				});
				this.headerOverlay.classList.remove('active');
			}
		});

		// mobile menu button handler
		const btnMobileMenu = this.el.querySelector('.site-header__mobile-menu-button');

		if (btnMobileMenu) {
			btnMobileMenu.addEventListener('click', () => {
				document.documentElement.classList.toggle('mobile-menu-active');
			});
		}

		// update header height on resize
		window.addEventListener('resize', () => this.updateHeaderHeightVar());

		// update header height on scroll
		window.addEventListener('scroll', () => {
			this.updateHeaderHeightVar();
			this.closeMenuOnScroll();
		});
	}

	updateHeaderHeightVar() {
		this.headerHeight = this.el.offsetHeight;
	}

	closeMenuOnScroll() {
		this.megaMenuItems.forEach(mml => {
			mml.classList.remove('active');
		});
		this.headerOverlay.classList.remove('active');
	}
}

export default SiteHeader;
